import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  linkBox: {
    display: 'inline-block',

    '&:hover > a': {
      color: theme.primary.p3,
      cursor: 'pointer',
    },
  },
}));

export default useStyles;
